export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'all',
    action: 'view_home_page',
  },
  {
    title: 'Services',
    route: 'services',
    icon: 'GridIcon',
    resource: 'all',
    action: 'manage_services',
  },
  {
    title: 'Latest News',
    route: 'latest-news',
    icon: 'BellIcon',
    resource: 'all',
    action: 'manage_latest_news',
  },
  {
    title: 'Portfolios',
    route: 'portfolio',
    icon: 'FileIcon',
    resource: 'all',
    action: 'manage_portfolios',
  },
  {
    title: 'Projects',
    route: 'projects',
    icon: 'BoxIcon',
    resource: 'all',
    action: 'manage_projects',
  },
  {
    title: 'Faqs',
    route: 'faqs',
    icon: 'BoxIcon',
    resource: 'all',
    action: 'manage_faqs',
  },
  {
    title: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Clients',
        route: 'clients',
        resource: 'all',
        action: 'manage_clients',
      },
      {
        title: 'Admins',
        route: 'admins',
        resource: 'all',
        action: 'manage_admins',
      },
      {
        title: 'Representatives',
        route: 'representative',
        resource: 'all',
        action: 'manage_representatives',
      },
    ],
  },
  {
    title: 'Roles',
    route: 'roles',
    icon: 'AwardIcon',
    resource: 'all',
    action: 'manage_roles',
  },
  {
    title: 'Requests',
    icon: 'MailIcon',
    children: [
      {
        title: 'Contact Requests',
        route: 'contact-requests',
        resource: 'all',
        action: 'manage_contact_requests',
      },
      {
        title: 'Service Requests',
        route: 'service-requests',
        resource: 'all',
        action: 'manage_service_requests',
      },
      {
        title: 'Register Requests',
        route: 'register-requests',
        resource: 'all',
        action: 'manage_register_requests',
      },
      {
        title: 'Transfer Contract Requests',
        route: 'transfer-requests',
        resource: 'all',
        action: 'manage_transfer_requests',
      },
      {
        title: 'Cancel Contract Requests',
        route: 'cancel-requests',
        resource: 'all',
        action: 'manage_cancel_contract_requests',
      },
    ],
  },

  {
    title: 'Notifications',
    route: 'notifications',
    icon: 'BellIcon',
    resource: 'all',
    action: 'manage_notifications',
  },
  {
    title: 'Settings',
    route: 'settings',
    icon: 'SettingsIcon',
    resource: 'all',
    action: 'manage_settings',
  },
  {
    title: 'Locations',
    icon: 'MapIcon',
    children: [
      {
        title: 'Countries',
        route: 'countries',
        resource: 'all',
        action: 'manage_countries',
      },
      {
        title: 'Cities',
        route: 'cities',
        resource: 'all',
        action: 'manage_cities',
      },
      {
        title: 'Areas',
        route: 'areas',
        resource: 'all',
        action: 'manage_areas',
      },
    ],
  },
  // {
  //   title: 'CRUD Page',
  //   route: 'third-page',
  //   icon: 'HomeIcon',
  // },
]
